import { StakingButton, StakingLayout } from '../../../entities/Staking';
import { PaddedContainer, RulesImg } from '../styles';
import { ContentBlock } from '../../../shared/ui/ContentBlock';
import { Column, Row } from '../../../globalStyles';
import styled from 'styled-components';
import { Link } from '@tanstack/react-router';
import { useTranslation } from '../../../language';

export const NFTStakingRules = () => {
    const { t } = useTranslation();

    return (
        <StakingLayout title={t('staking.nft.title')}>
            <Column gap={20} fullWidth>
                <ContentBlock variant="staking" size="large">
                    <PaddedContainer>
                        <ContentBlock>
                            <RuleRow gap={8}>
                                <RulesImg src="/staking/dog.png" />
                                <RuleText>{t('staking.nft.rules.1')}</RuleText>
                            </RuleRow>
                        </ContentBlock>
                        <ContentBlock>
                            <RuleRow gap={8}>
                                <RulesImg src="/wallet/punk.png" />
                                <RuleText
                                    dangerouslySetInnerHTML={{
                                        __html: t('staking.nft.rules.2')
                                            .replaceAll('<>', '<span>')
                                            .replaceAll('</>', '</span>'),
                                    }}
                                />
                            </RuleRow>
                        </ContentBlock>
                        <ContentBlock>
                            <RuleRow gap={8}>
                                <RulesImg src="/staking/gold.png" />
                                <RuleText
                                    dangerouslySetInnerHTML={{
                                        __html: t('staking.nft.rules.3')
                                            .replaceAll('<>', '<span>')
                                            .replaceAll('</>', '</span>'),
                                    }}
                                />
                            </RuleRow>
                        </ContentBlock>
                    </PaddedContainer>
                </ContentBlock>
                <Link to="/staking/levels" style={{ width: '100%' }}>
                    <StakingButton>{t('staking.levels.title')}</StakingButton>
                </Link>
            </Column>
        </StakingLayout>
    );
};

const RuleRow = styled(Row)`
    padding: 10px;
    align-items: flex-start;
`;

const RuleText = styled.p`
    font-size: 14px;

    & > span {
        font-size: inherit;
        font-weight: 700;
    }
`;
